(function (ws) {
    'use strict';

    ws.views.CustomerOnboardingHeader = Backbone.View.extend({

        events: {
            'change .languageSelect': 'callCountryModel',
            'click .languageSelect': 'toggleArrowIcon',
            'click .logoutDiv': 'checkLogout'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$languageForm = this.$('.languageForm');
            this.$arrowIcon = this.$('.arrow-icon');
            $(document).on('click', this.onDocumentClick.bind(this));
            this.eventAgg.on('searchSelectedLanguage', this.searchSelectedLanguage.bind(this));
        },

        searchSelectedLanguage: function(from, countyType) {
            if (!(this.$('#countryCode').val())) {
                this.$('#countryCode').val($('#country-' + countyType).val());
            }

            if (from === 'language') {
                this.$('#countryCode').val('');
            } else {
                this.$('.languageSelect').val('');
            }

            this.$('#landingpage').val($('#pageName').val() === 'CustomerOnBoardLandingPage');
            this.$languageForm.submit();
        },

        callCountryModel: function(e) {
            if ($('#pageName').val() === 'CustomerOnBoardLandingPage') {
                this.searchSelectedLanguage('language');
            } else {
                this.eventAgg.trigger('searchSelectedLanguageChange', e, 'language');
            }
        },

        /*
        *Toggles the arrow icon from up to down and back.
        */
        toggleArrowIcon: function() {
            if (this.$arrowIcon.hasClass('icon-downarrow')) {
                this.$arrowIcon
                    .removeClass('icon-downarrow')
                    .addClass('icon-uparrow');
            } else if (this.$arrowIcon.hasClass('icon-uparrow')) {
                this.$arrowIcon
                    .removeClass('icon-uparrow')
                    .addClass('icon-downarrow');
            }
        },

        /*
         *Toggles the arrow icon from up to down and back.
         */
        onDocumentClick: function() {
            if (event && !$(event.target).closest('.languageSelect').length) {
                this.$arrowIcon
                    .removeClass('icon-uparrow')
                    .addClass('icon-downarrow');
            }
        },

        checkLogout: function(e) {
            e.preventDefault();
            if ($('#pageName').val() !== 'CustomerOnBoardLandingPage') {
                this.eventAgg.trigger('checkIfLoggedOut');
            } else {
                window.location.href = globals.path.api.westcon.logout;
            }
        }
    });
})(westcon);
